/* GASSISA
=========================================================================================
* Descripcion: Version portatil del formulario de reporte ventas almacen.
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revision   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 26/06/2026 | Lic. Jose Luis Aragon Cervantes  | Creacion de version portatil responsiva
* ---------------------------------------------------------------------------------------
*/

import FrmReporteVentasAlmacen from "../../administracion/FrmReporteVentasAlmacen.jsx";
import SizeSoftXFrmPortatil from "../leyout/SizeSoftXFrmPortatil.jsx";

export default function FrmReporteVentasAlmacenPortatil() {
  return (
    <SizeSoftXFrmPortatil nombreFormulario="FrmReporteVentasAlmacen">
      <FrmReporteVentasAlmacen />
    </SizeSoftXFrmPortatil>
  );
}
